import React from "react";
import { NextSeo } from "next-seo";
import server from "../src/api/server";

import { useIntl } from "react-intl";
import Faqs from "../src/components/faqs";
import BreadCrumb from "../src/components/Shared/BreadCrumb";

const FaqsPage = ({ faqsData, breadBackground , metaDataSections }) => {
  const { formatMessage , locale } = useIntl();
  const faqs = metaDataSections?.find(item=>item?.slug==='faqs')
  return (
    <>
       <NextSeo
                title={faqs?.name[locale] || formatMessage({ id: faqs?.slug })}
                description={faqs?.description[locale] || 
                  formatMessage({ id: "Walid Ben Abdulaziz Ben mouzan" })
                }
                additionalMetaTags={[
                    {
                        name: "keywords",
                        content: "",
                    },
                    {
                        name: "description",
                        content: "",
                    },
                ]}
            />
      <div className="faqs-page">
        <BreadCrumb
          title={formatMessage({ id: "faqs" })}
          pageTitle={formatMessage({ id: "faqs" })}
          breadBackground={breadBackground}
        />
        <Faqs {...{ faqsData }} />
      </div>
    </>
  );
};

export const getStaticProps = async (ctx) => {
  try {
    const faqsResponse = await server.get("/pages/faqs");
    const backgroundResponse = await server.get("/pages/backgrounds");
    const metaDataResponse = await server.get("/pages/metaData");
    const breadBack = backgroundResponse?.data?.data?.page?.sections?.find(
      (sec) => sec?.slug === "breadcrumbs"
    )?.image;

    return {
      revalidate: 1,
      props: {
        faqsData: faqsResponse?.data?.data?.page?.sections,
        metaDataSections : metaDataResponse?.data?.data?.page?.sections ,
        breadBackground: breadBack
          ? `${process.env.NEXT_PUBLIC_MAIN_URL}/${breadBack}`
          : null,
      },
    };
  } catch (error) {
    return {
      revalidate: 1,
      props: {
        error: JSON.stringify(error),
      },
    };
  }
};
export default FaqsPage;
